/**
 * 用户管理
 * @author limy
 */
import api from '@/services/api'
import {METHOD, request} from '@/utils/request'

export const dataApi = {
    async getFormDetail(keyId) {//获取详情
        return request(api.clue.CLUE + "/" + keyId, METHOD.GET);
    },
    async getReportList(clueId) {//获取详情
        return request(api.clue.REPORT, METHOD.GET, {'clueId': clueId});
    },
    async getCostList() {//关联客户下拉数据
        return request(api.clue.CLUE + '/getCostList', METHOD.GET);
    },
    async getCommCode() {//意向品牌 品系 下拉数据
        return request(api.clue.CLUE + '/getCommCode', METHOD.GET);
    },
    async saveFormDetail(result) {//保存或修改
        return request(api.clue.CLUE, METHOD.POST, result);
    },
    async getPoolList() {//获取线索池详情
        return request(api.clue.CLUEPOOL, METHOD.GET);
    },
    async getPoolFormDetail(keyId) {//获取线索池详情
        return request(api.clue.CLUEPOOL + "/" + keyId, METHOD.GET);
    },
    async getPoolAssign(result) { // 经销商分配销售顾问
        return request(api.clue.CLUEPOOL + "/distribute", METHOD.GET, result);
    },
    async getPoolReceive(result) { //经销商销售顾问领取
        return request(api.clue.CLUEPOOL + "/receive", METHOD.GET, result);
    },
    async getPoolToVoid(result) { // 作废线索池
        return request(api.clue.CLUEPOOL + "/toVoid", METHOD.GET, result);
    },
    async getPoolTransfer(result) { // 转移线索池
        return request(api.clue.CLUEPOOL + "/transfer", METHOD.GET, result);
    },
    async selection(params) {
        return request(api.client.SELECTION, METHOD.GET, params)
    },
    async downErrorFile(url) {
        return request(api.temp.FILE_PATH + 'error/' + url, METHOD.GET, {download: 1})
    },
    async rollbackClue(ids) {
        return request(api.clue.CLUEPOOL + '/rollbackClue?idList=' + ids, METHOD.GET)
    },
    async popSelect() {
        return request(api.comm.DEPT + '/popSelect', METHOD.GET);
    },
    async getStrainList() { //品系
        return request(api.clue.CLUE + "/getStrainList", METHOD.GET);
    },

}


export default {dataApi}
